/**
* This is a base class for a searchable object, e.g. an incident or a maintenance.
* Note that you cannot use this class directly, you must extend it with your own class and override the "matchesSaarch" method
* @author Joerg Peschke
**/

import {ISearchableObject} from './rz-status_models'
import Constants from './rz-status_constants'


export default class AbstractSearchableObject  implements ISearchableObject {


	/**
	* Should be overridden in extending class
	**/
	 public matchesSearch (searchTerm:string, fields:string[]):boolean {
	 	throw new Error ("This method is abstract and must be overrided.");
	 }
	 /**
	 * Method to check whether a search term matches a text
	 * @param searchTerm the search term eneterd by the user
	 * @param text the text to search for occurances of the search term
	 * @return true if the search term matches the text
	 **/
	 public matchesFreeText (searchTerm:string, text:string):boolean {
	 	searchTerm = this.normalize(searchTerm);
	 	text = this.normalize(text);
	 	var regExp:RegExp = this.createRegExp(searchTerm);
	 	return(text.match(regExp) != null);
	 }

	 /**
	 * Checks whether a search term matches a certain date. The search term can have the format "DD.MM" , "DD.MM.YYYY", "DD.MM.YYYY HH" or "DD.MM.YYYY HH:mm"
	 * @param searchTerm a search term the user has entered
	 * @param date a date to check against the search term
	 **/

	 public matchesDate (searchTerm:string, date:Date):boolean {
	 	searchTerm = searchTerm.replace(/\s+?/," ");
	 	var format:string = "";
	 	if ((searchTerm.length > Constants.DateFormat.searchPattern.length) || (searchTerm.match(/^\d/) == null)) {
	 		return(false);
	 	}
	 	else if (searchTerm.length < 2) {
	 		return(true);
	 	}
	 	else if (searchTerm.length < 5) {
	 		searchTerm = searchTerm.substring(0,2);
	 		format = Constants.DateFormat.searchPattern.substring(0,2);
	 	}
	 	else if (searchTerm.length < 10) {
	 		searchTerm = searchTerm.substring(0,5);
	 		format = Constants.DateFormat.searchPattern.substring(0,5);
	 	}
	 	else if (searchTerm.length < 13) {
	 		searchTerm = searchTerm.substring(0,10);
	 		format = Constants.DateFormat.searchPattern.substring(0,10);
	 	}
	 	else if (searchTerm.length < 16) {
	 		searchTerm = searchTerm.substring(0,13);
	 		format = Constants.DateFormat.searchPattern.substring(0,13);
	 	}
	 	return (moment(date).format(format) === searchTerm);

	 }


	 /**
	 * Normalize a text (toLowercase, replacing special characters, replacing german umlauts etc.)
	 * @param text a text to be normalized
	 * @return the normalized text
	 **/
	 private normalize(text:string):string {
	 	text = text.toLowerCase()
	 				.replace(/([,+-]*\s)/gi, " ")	 				
	 				.replace(/ä/g,"ae")
	 				.replace(/ö/g,"oe")
	 				.replace(/ü/g,"ue")
	 				.replace(/Ä/g,"Ae")
	 				.replace(/Ö/g,"Oe")
	 				.replace(/Ü/g,"Ue")
	 				.replace(/ß/g,"ss")
	 				.replace(/\s+?/, " ");
	 	return(text);
	 }
	 /**
	 * Create a regexp object from a search term (escaping characters reserved for regular expressions)
	 * @param searchTerm a search term entered by a user
	 * @return a RegExp object representing the search term
	 **/
	 private createRegExp (searchTerm:string):RegExp {
	 	searchTerm = searchTerm.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
	 	return(new RegExp(searchTerm));
	 }
}

